export enum CreateOrUpdate {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
}
